import { Component, Input, OnInit } from '@angular/core';
import { Config, InvestmentModelForInvestorTypeShort, InvestmentModelShort } from '../../../../shared/model/interfaces';
import { AuthService, GridConfigItem } from '../../../../shared/service/auth.service';

@Component({
  selector: 'app-investments-block',
  templateUrl: './investments-block.component.html',
  styleUrls: ['./investments-block.component.scss']
})
export class InvestmentsBlockComponent implements OnInit {
  @Input() userInfo: {
    InActiveInvestments: InvestmentModelShort[] | InvestmentModelForInvestorTypeShort[],
    ActiveInvestments: InvestmentModelShort[] | InvestmentModelForInvestorTypeShort[],
    TotalInActiveCommitmentAmt: number,
    TotalInActiveCapitalAmt: number,
    TotalInActiveUnits: number,
    TotalInActiveValueAmt: number,
    TotalInActiveOrigCapitalAmt: number,
    TotalActiveCommitmentAmt: number,
    TotalActiveCapitalAmt: number,
    TotalActiveUnits: number,
    TotalActiveValueAmt: number,
    TotalActiveOrigCapitalAmt: number
  };

  inactiveInvestmentsConfig: Config;
  activeInvestmentsConfig: Config;

  constructor(private authService: AuthService) {
    const userType = this.authService.UserType;
    if (userType === 'I') {
      this.inactiveInvestmentsConfig = this.authService.getGridColumnConfigs(GridConfigItem.INACTIVE_INVESTMENT_HOME_PAGE);
      this.activeInvestmentsConfig = this.authService.getGridColumnConfigs(GridConfigItem.ACTIVE_INVESTMENT_HOME_PAGE);
    } else {
      this.activeInvestmentsConfig = this.authService.getGridColumnConfigs(GridConfigItem.ACTIVE_FUND_HOME_PAGE);
    }
  }

  ngOnInit(): void {
  }

}
